export const ARTICLE_FORM_NAME = 'article';



// WEBPACK FOOTER //
// ./src/modules/ArticleForm/constants.js